const validatePass = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('请输入密码'));
  }else if(value.length < 6) {
    callback(new Error('密码不能小于6位'));
  }else if(value.length > 20) {
    callback(new Error('密码不能大于20位'));
  }else if(value){
    let regExp = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/
    if (regExp.test(value) === false) {
      return callback(new Error('密码格式有误，必须同时包含数字和字母'));
    }else{
      callback();
    }
  } else {
    callback();
  }
};
const validatePhone = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('电话号码不能为空'));
  }else{
    let regExp = /(1[345789]\d{9})/;
    if (regExp.test(value) === false) {
      return callback(new Error('号码有误，请确认'));
    } else {
      callback();
    }
  }
};
const validateRechargeNum = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('充值额度不能为空'));
  }else if(value.slice(0,1) == "0"){
    return callback(new Error('充值额度不能以0开头'));
  }else{
    let regExp = /^[0-9]{1,10}$/
    if (regExp.test(value) === false) {
      return callback(new Error('只能输入正整数'));
    }else{
      callback();
    }
  }
};
const validateOverplus = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('短信变动额度不能为空'));
  }else if(value.slice(0,1) == "0"){
    return callback(new Error('短信变动额度不能以0开头'));
  }else{
    let regExp = /^[0-9]{1,10}$/
    if (regExp.test(value) === false) {
      return callback(new Error('只能输入正整数'));
    }else{
      callback();
    }
  }
};
const validataWarning = (rule, value, callback) => {
  if(!value) {
    return callback(new Error('请输入预警值'));
  }else{
    if(value < 100){
      return callback(new Error('请输入大于100的正整数'));
    }else{
      let regExp = /^[0-9]{1,10}$/
      if(regExp.test(value) === false){
        return callback(new Error('只能输入正整数'));
      }else{
        callback();
      }
    }
  }
};
export default{
  userName: [
    { required: true, message: '请输入用户名', trigger: 'blur' }//用户名
  ],
  userPhone: [
    { required: true, validator:validatePhone, trigger: 'blur' }//手机号
  ],
  userPassword:[
    { required: true, validator:validatePass, trigger: 'blur' }//密码
  ],
  codeImg: [
    { required: true, message: '验证码不能为空', trigger: 'blur' }//图片验证码
  ],
  rechargeNum: [
    { required: true, validator:validateRechargeNum, trigger: 'blur' }//充值额度
  ],
  newPass: [
    { required: true, validator: validatePass, trigger: 'blur' }//新密码
  ],
  balanceSizeWarn: [
    { required: true, validator: validataWarning, trigger: 'blur' }//预警值
  ],
  //模板
  mouldTypeId: [
    { required: true, message: '请选择模板类型', trigger: 'change' }
  ],
  mouldName: [
    { required: true, message: '请输入模板名称', trigger: 'blur' }
  ],
  mouldContent: [
    { required: true, message: '请输入模板内容', trigger: 'blur' }
  ],
  mouldReason: [
    { required: true, message: '请输入申请原因', trigger: 'blur' }
  ],
  //签名
  signName: [
    { required: true, message: '请输入签名内容', trigger: 'blur' },
  ],
  signReason: [
    { required: true, message: '请输入申请说明', trigger: 'change' }
  ],
  //通道
  priorLevel: [
    { required: true, message: '请输入通道使用优先级', trigger: 'blur' }
  ],
  overplus: [
    { required: true, validator: validateOverplus, trigger: 'blur' }
  ],
  
  //发送短信
  // userPhone: [
  //   { required: true, message: '请输入电话号码', trigger: 'blur' }
  // ],
    
}



// WEBPACK FOOTER //
// ./src/rules/index.js